// extracted by mini-css-extract-plugin
export default {"legend-item":"LegendItem_legend-item__MLROV","legend-item__marker":"LegendItem_legend-item__marker__Om29e","legend-item__title":"LegendItem_legend-item__title__xqQvQ"};